/*
    Copyright 2022 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

// ----------------------------------------------------------------------------
export function checkNumericOption<T>(component: string, options: T | undefined, prop: keyof T, defaultVal: number): number {
	if (options == null) {
		return defaultVal;
	}
	const val = options[prop];
	if (val != null) {
		if (typeof(val) !== "number") {
			throw new TypeError(`${component}: ${prop.toString()} must be a number`);
		}
		return val;
	}
	return defaultVal;
}

// ----------------------------------------------------------------------------
export function checkStringArrayOption(val: unknown): val is string[] {
	if (val == null) {
		return false;
	}

	if (!Array.isArray(val)) {
		return false;
	}

	for (const element of val) {
		if (typeof(element) !== "string") {
			return false;
		}
	}

	return true;
}

// ----------------------------------------------------------------------------
export function checkBooleanOption<T>(component: string, options: T | undefined, prop: keyof T, defaultVal: boolean): boolean {
	if (options == null) {
		return defaultVal;
	}
	const val = options[prop];
	if (val != null) {
		if (typeof(val) !== "boolean") {
			throw new TypeError(`${component}: ${prop.toString()} must be a boolean`);
		}
		return val;
	}
	return defaultVal;
}
